import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { TableSportsRowLink } from 'src/ui/components/table/sports/row/link/TableSportsRowLink';
import { withConfig } from 'src/withConfig';

interface TableSportsRowItemWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setTableSportsRowItemWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.medium};
            border: none;
        `;
    }
    return css`
        border-width: 0 0 1px 0;
        @media ${theme.star.mediaQuery.tablet} {
            border-width: 0 1px 1px 0;
            &:only-of-type {
                border-right: 0;
            }
            &:not(:only-of-type) {
                flex: 0 0 50%;
                width: 50%;
            }
            &:last-of-type {
                border-bottom: 0;
            }
            &:nth-of-type(even) {
                border-right: 0;
            }
            &:nth-last-of-type(2):nth-of-type(odd) {
                border-bottom: 0;
            }
        }
    `;
};

export const TableSportsRowItemWrapper = withConfig(theme => styled(TableSportsRowLink, { label: 'TableSportsRowItemWrapper' })<TableSportsRowItemWrapperPropsType>`
    ${({ variant }): SerializedStyles => setTableSportsRowItemWrapper(variant, theme)}
    padding-right: 48px;
`);
